'use strict';
/**
 * Nurse can share thier profile with any third party.
 */
App.service('shareProfile', shareProfile);

function shareProfile($http, $q, $sessionStorage, Api, $loading, ngDialog, $state, toastr, ProfessionalService, $localStorage) {
  this.share = share;
  async function share() {
      const currentScreen = $state.current.name === 'splash' ? 'splash' : 'home';
    $loading.start(currentScreen);
    try {
        const { url } = await ProfessionalService.shareBriefcase($localStorage['token'], 'overview');
        dialogOpen(url);
    }catch (e) {
        toastr.error(e.message);
    } finally {
        $loading.finish(currentScreen);
    }
  }

    function dialogOpen(url) {
        ngDialog.open({
            template:'<div dw-loading="link" class="dialog-contents dialog-contents text-center nurse-popup">' +
            ' <div class="ngdialog-close" ng-click="closed()" style="z-index: 99;"></div>' +
            '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center imgSrc">' +
            '	<img src="img/profileshare.svg">' +
            '</div>' +
            '<span class="shareTitle">Share Your Profile</span>' +
            '<p class="titleDesc">You control <b>what</b> and <b>who</b> you want to share</p>' +
            '<p class="titleDesc" title="Resume style for recruiters and professional use"><label><input ng-click="changeAccessLevel($event)" type="radio" value="overview" name="profile" checked><span style="padding-left:5px; cursor:pointer;">Profile view - Resume style for recruiters and professional use</span></label></p>' +
            '<p class="titleDesc" title="Health info, DOB and SSN for credentialing/onboarding"><label><input ng-click="changeAccessLevel($event)" type="radio" value="full" name="profile"><span style="padding-left:5px; cursor:pointer;">Full Access - Health info, DOB and SSN for credentialing/onboarding</span></label></p>' +
            '<p class="titleDesc" style="text-align: center;">You can share your Briefcase with this link.</p>' +
            '<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center mt-2">' +
            '<input id="privateUrl" type="text" ng-value="url" class="form-control shareUrl" readonly>' +
            '<span class="urlValid" style="line-height: 16px;margin-top: 3px;">Anyone who has the link can view. To ensure' +
            ' your security, this link will expire in 14 days.</span>' +
            '</div>' +
            '<div class="col-lg-12 col-md-12 col-sm-12 com-xs-12 text-center">' +
            '<button class="yesButton shareButton"  style="margin-top: 20px;" type="submit" onclick="copyToClipboard()"' +
            ' onmouseout="outFunc()">' +
            '<span class="yesText" id="copyToClipboardTooltip">Copy Link</span>' +
            '</button>' +
            '</div>' +
            '</div>',
            className: 'ngdialog-theme-default documentation-dialog prn-dialog incompleteDashboard',
            data: {url},
            closeByNavigation: true,
            showClose: false,
            closeByDocument: false,
            closeByEscape: false,
            plain: true,
            controller: ['$scope', '$loading', 'ProfessionalService', '$localStorage', 'toastr', function ($scope, $loading, ProfessionalService, $localStorage, toastr) {
                $scope.url = $scope.ngDialogData.url;
                $scope.shortURL = '';
                $scope.closed = function () {
                    ngDialog.closeAll();
                };
                $scope.changeAccessLevel = async function (evt) {
                    var accessType = evt.target.value;
                    $loading.start('link');
                    try {
                        const { url } = await ProfessionalService.shareBriefcase($localStorage['token'], accessType);
                        $scope.url = url;
                        $scope.$apply();
                    } catch (e){
                        toastr.error(e.message);
                    } finally {
                        $loading.finish('link');
                    }
                };
            }]
        });
    }

}

function copyToClipboard() {
    var copyText = document.getElementById("privateUrl");
    copyText.select();
    document.execCommand("copy");

    var tooltip = document.getElementById("copyToClipboardTooltip");
    tooltip.innerHTML = "Link Copied";
}

function outFunc() {
    var tooltip = document.getElementById("copyToClipboardTooltip");
    tooltip.innerHTML = "Copy Link";
}

